import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const PressureHolderQuantity = (props) => {
  const {
    onChangeParameter,
    parameters,
    name,
    label,
    inputId,
    required,
    tooltip,
    children,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);
  const value = parameters[name];

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={value || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      min="1">
      {children}
    </TextComponent>
  );
};

PressureHolderQuantity.defaultProps = {
  label: 'Total Number of Pressure Holders',
  name: 'pressure_holder_quantity',
};

export default PressureHolderQuantity;
